(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/banner-service/assets/javascripts/banner-service.js') >= 0) return;  svs.modules.push('/components/content/banner-service/assets/javascripts/banner-service.js'); "use strict";

(function (svs) {
  'use strict';

  const {
    preRenderSetup: videoPreRenderSetup
  } = svs.components.emp_video_player.contentLoader;
  svs.content = svs.content || {};
  svs.content.bannerService = svs.content.bannerService || {};

  svs.content.bannerService = function (svs) {
    function trackClick(e) {
      const track = e.currentTarget.getAttribute('data-track');

      if (track) {
        const areaName = e.currentTarget.getAttribute('data-area-name') || 'unknown';
        const evt = {
          id: track,
          name: track,
          position: areaName
        };

        if (e.currentTarget.getAttribute('target') && e.currentTarget.getAttribute('target') !== '_self') {
          svs.components.analytics.trackPromoClick(evt);
          return true;
        }

        svs.components.analytics.trackPromoClick(evt, () => {
          document.location = e.currentTarget.getAttribute('href');
        });
        return false;
      }
    }

    $('body').on('click', '.js-banner', trackClick);

    function init(data) {
      const groupedBanners = data && data.model && data.model.groupedBanners;

      if (groupedBanners) {
        groupedBanners.reduce((banners, group) => banners.concat(group.background || group.column), []).forEach(banner => {
          const $bannerEl = data.$el.find("[data-banner-id=\"".concat(banner.id, "\"]"));
          handleLayer($bannerEl, data, banner);
          handleOddsetPlayable($bannerEl, data, banner);
          handleForm($bannerEl, data, banner);
          handleVideo($bannerEl, data, banner);
        });
      }
    }

    function handleOddsetPlayable($bannerEl, data, banner) {
      const $el = $bannerEl.find('.js-oddset-playable');

      if ($el && $el.length > 0) {
        new svs.sport.bannerTypeOddsetPlayable.OddsetPlayable($el, data, banner);
      }
    }

    function handleForm($bannerEl, data, banner) {
      const $el = $bannerEl.find('.js-form');

      if ($el && $el.length > 0) {
        new svs.content.bannerTypeForm.Form($el, data, banner);
      }
    }

    function handleLayer($bannerEl, data, banner) {
      const $el = $bannerEl;

      if (banner.subtype === 'layersBanner' && $el && $el.length) {
        new svs.content.bannerTypeLayer.LayerBanner($el[0]);
      }
    }

    function handleVideo(bannerElement, data, banner) {
      if (banner && banner.video && banner.video.type === 'redbee') {
        videoPreRenderSetup(bannerElement[0]);
      }
    }

    return {
      init
    };
  }(svs);
})(svs);
 })(window);